export default class Tooltip {
    constructor() {
        this.activeTarget = null;
        this.tooltip = document.getElementById('tooltip');

        document.addEventListener('pointerover', e => {
            const target = e.target.closest('[data-tooltip]');

            if (!target) {
                return;
            }

            if (e.pointerType !== 'mouse') {
                return;
            }

            if (this.activeTarget === target) {
                return;
            }

            const tooltipText = target.dataset.tooltip;

            if (!tooltipText) {
                return;
            }

            if (target.classList.contains('text') && target.scrollWidth <= target.clientWidth) {
                return;
            }

            this.activeTarget = target;
            this.show(tooltipText);
        });

        document.addEventListener('pointerout', e => {
            const target = e.target.closest('[data-tooltip]');

            if (target && this.activeTarget && (!e.relatedTarget || !target?.contains(e.relatedTarget))) {
                this.activeTarget = null;
                this.hide();
            }
        });

        document.addEventListener('fullscreenchange', () => {
            const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement;
            const activeContainer = fullscreenElement || document.body;


            if (!fullscreenElement) {
                document.body.appendChild(this.tooltip);
                this.hide();
            } else if (this.tooltip.parentElement !== activeContainer) {
                activeContainer.appendChild(this.tooltip);
            }
        });
    }

    show(text) {
        this.tooltip.textContent = text;

        const rect = this.activeTarget.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        const gap = 5;
        let top = rect.top + this.activeTarget.offsetHeight + gap;
        let left = rect.left + (rect.width / 2) - (this.tooltip.offsetWidth / 2);

        if (top < 0) {
            top = rect.bottom + gap;
        }

        if (left < 5) {
            left = rect.left;
        }

        const rightBoundary = window.innerWidth - this.tooltip.offsetWidth - 5;

        if (left > rightBoundary) {
            left = rect.left + rect.width - this.tooltip.offsetWidth;
        }

        this.tooltip.style.transform = 'translate(' + Math.ceil(left + scrollLeft) + 'px, ' + Math.ceil(top + scrollTop) + 'px)';
        this.tooltip.style.opacity = 1;
        this.tooltip.setAttribute('aria-hidden', 'false');
    }

    hide() {
        this.tooltip.style.opacity = 0;
        this.tooltip.style.transform = 'translate(-100px, 0)';
        this.tooltip.textContent = null;
        this.tooltip.setAttribute('aria-hidden', 'true');
    }
}